export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)

  if (!current || !url) {
    return false
  }

  // Check for exact match
  if (current === url) {
    return true
  }

  // Check if current starts with url and has a separator (/, ?, #) right after
  const urlWithSlash = `${url}/`
  if (current.startsWith(urlWithSlash) || current === url) {
    return true
  }

  return false
}

